var _style, _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMicrophone = function SvgMicrophone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14.3 20",
    style: {
      enableBackground: "new 0 0 14.3 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#698DB0;}\n")), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Combined Shape Copy 5")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Webphone_new_14_sound_n_devices",
    transform: "translate(-26.000000, -377.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy-2",
    transform: "translate(0.000000, 331.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-5",
    className: "st0",
    d: "M40.3,28.6c0,3.7-2.9,6.8-6.5,7.1v2.1h2.7c0.3,0,0.6,0.3,0.6,0.6 c0,0.3-0.3,0.6-0.6,0.6h-6.5c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6h2.7v-2.1c-3.7-0.3-6.5-3.4-6.5-7.1 c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6c0,3.3,2.7,5.9,5.9,5.9s5.9-2.7,5.9-5.9c0-0.3,0.3-0.6,0.6-0.6 C40,28,40.3,28.2,40.3,28.6z M30.5,22.9v5.7c0,1.5,1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7v-5.7c0-1.5-1.2-2.7-2.7-2.7 C31.7,20.2,30.5,21.4,30.5,22.9z M33.1,32.4c-2.1,0-3.9-1.7-3.9-3.9v-5.7c0-2.1,1.7-3.9,3.9-3.9c2.1,0,3.9,1.7,3.9,3.9v5.7 C37,30.7,35.3,32.4,33.1,32.4z"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicrophone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/microphone.46cf8f65.svg";
export { ForwardRef as ReactComponent };